import { clearActivity } from "./sessionActivity";
import { clearAllDiaryDraftsBannerDismissed } from "./diaryDraftsBannerStorage";
import { postEndStaffImpersonation } from "@/api/meApi";
import { resetGoogleGis } from "./googleGis";
import { supabase } from "./supabase";
import { queryClient } from "@/lib/queryClient";
import { useAuthStore } from "@/store/authStore";

const LEGACY_ACTIVE_ORG_KEY = "konstrulog.activeOrganizationId";

/** Clears Supabase session (if configured), all query cache, and local auth store. */
export async function signOutClient(): Promise<void> {
  const userId = useAuthStore.getState().session?.id;
  clearActivity();
  try {
    await postEndStaffImpersonation();
  } catch {
    /* best effort — session ends server-side on next auth cycle */
  }
  resetGoogleGis();
  try {
    localStorage.removeItem(LEGACY_ACTIVE_ORG_KEY);
  } catch {
    /* ignore */
  }
  try {
    if (supabase) await supabase.auth.signOut();
  } catch {
    /* Still clear local state so the user can retry sign-in */
  }
  queryClient.clear();
  useAuthStore.getState().logout();
  if (userId) {
    clearAllDiaryDraftsBannerDismissed(userId);
  }
}
